import { darkChrome as chrome } from './chrome';

const breakpoints = {
  xs: '400px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
};

const mediaQueries = {
  xs: `@media (max-width: ${breakpoints.xs})`,
  sm: `@media (max-width: ${breakpoints.sm})`,
  md: `@media (max-width: ${breakpoints.md})`,
  lg: `@media (max-width: ${breakpoints.lg})`,
  xl: `@media (max-width: ${breakpoints.xl})`,
  gtSm: `@media (min-width: ${parseInt(breakpoints.sm) + 1}px)`,
};

const darktheme = {
  ...mediaQueries,
  primary: '#fff',
  primaryDark: '#0d2349',
  secondaryLight: 'hsla(218, 41%, 19%, 0.10)',
  filterHoverBg:'#9EA7B640',
  secondary:'#dc601e',
  lightText:'#fff',
  sideBar: chrome.header,
  primaryLight: '#9EA7B626',
  primaryText: '#FFFFFFCC',
  bgPebble:'#dcdcdd',
  bgPebbleLight:'#dcdcdd9f',
  primaryLight2: '#9EA7B626',
  darkPurple: '#280329',
  purpleLight: '#351236',
  purpleBorder:'#774B78',
  purpleBtnBorder:'#4d2e4e',
  lightYellowAutomation: '#FDF4ED',
  primaryLight3: '#001F5C1f',
  primaryLight4: '#e9e9e9',
  water: '#1c1c1c',
  fantasy: '#FDF4ED',
  primaryDisabled: '#EDEDED',
  lightBlack:' #0A0509',
  headingColor: '#fff',
  textMuted: '#F5F5F5',
  body: '#000000',
  textColor: '#F5F5F5',
  textColor2:'#eaeaea',
  lightGray: '#FCFCFC',
  iconGray: '#A4A2A4',
  lightHover: '#FAFAFA',
  inputDisabled: '#707070',
  lightBoldBlack: '#9C9C9C',
  tagBg:'#FFFFFF1A',
  purple: "#F6EFFF",
  skyblue: "#EFF4FA",
  thunder: "#292D32",
  inputBorder: '#373737',
  bodyBg: chrome.workspace,
  white: '#121212',
  WhiteLinen: '#E7EFDC',
  lightbrown: "#F0E9D9",
  finch: '#5B6251',
  berylGreen: '#D8E6C6',
  subText: '#9C9C9C',
  inputPlaceHolder: '#9C9C9C',
  successColorSky: '#00796B',
  inputColor: '#787377',
  defaultImage: '#8C0020',
  danger: '#E45353',
  skygreen: '#E0F2F1',
  success: '#6EAA64',
  lightGreen: '#c1e8eb33',
  tuna: '#33383F',
  orange: '#DBA745',
  blue: '#001F5C',
  gold: '#996B00',
  occyLogo: '#EC008C',
  successLight: '#ECF5EA',
  tagLightBlue: '#EDF1FC',
  tagBlueColor: '#6D93C9',
  tagLightgray: '#A4ADA3',
  tagLightYellow: '#FCF1E9',
  statusTextColor: '#F8F2F7',
  statusTagOverDue: '#5C1F1F',
  statusTagCompleted: '#1E423C',
  statusTagSent: '#4A154B',
  statusTagNotSent: '#996B00',
  statusTagNew: '#1E3F6E',
  statusTagPending: '#996B00',
  statusTagAwaiting: '#996B00',
  statusAwaitingColor: '#664700',
  lightPinkish: '#F5EAF3',
  lightSlam:'#c3a2be',
  babyPink:'#FFC1F6',
  TagCompletedBg :'#1E423C',
  chartBorderColor:'#E5E5E5',
  notesColorSent: '#BFAB61',
  notesColorOverDue: '#AF6060',
  notesColorCompleted: '#6F876F',
  lightGreenNew: '#E6F4F4',
  crystal: '#B2D3D6',
  noteTags: '#C2D3EB80',
  borderColor: '#767476',
  borderLight: '#E0E0E0',
  cornSilk: '#FFF9E5',
  bgPink: '#F9F5F6',
  darkGraydarkMode: '#E6E5E6',
  eventColor1: '#F4DDE5',
  eventColor2: '#DADAF3',
  eventColor3: '#F4E5DE',
  eventColor4: '#ECEEEF',
  eventColor5: '#DCEAF5',
  interviewAttend: '#E3F1FF',
  darkText: '#F5F5F5',
  blueIcon: '#204B8C',
  formSettingCardDesc: '#6F767E',
  hintBg: '#3B393C',
  green: '#1E423C',
  lightYellow: '#996B00',
  dullVoilet:'#73308A',
  chartFilled: '#A5A5E9',
  chartVacant: '#F7CEB5',
  LavenderColor: '#E0F3F5',
  NCSColor: '#E0E9F5',
  LineChartBorder: "#775078",
  ChartDashes: "#ABADB5",
  eventGreen: '#00796B',
  pyramidInterviewed: '#8D6587',
  pyramidOffered: '#521753',
  triggerIconColor: '#775078',
  chartManual: '#DC89A6',
  doughGraphtooltipTitle: '#2F0D30',
  tootipBg: '#CCB2C8',
  doughplaceholderColor: '#d2dee2',
  lineGraphBorderColor: '#8F8FF0',
  lightBgPink: "#FDFDFD",
  funnelIndex1: '#b68fb0',
  funnelIndex3: '#73486d',
  funnelIndex4: '#5e2f5e',
  graphPrimary: '#dcdcdd',
  graphOrange: '#D97109',
  teamLabelbg: 'rgba(194, 211, 235, 0.2)',
  scheduleSelfSlotInfoColor: 'rgba(255, 246, 218, 0.3)',
  greenBarylLightColor: '#1E423C',
  orangeProcessingColor: 'rgba(219,167,69, 0.4)',
  dangerFailColor: 'rgba(255,0,0,0.4)',
  selfGrey: 'rgba(252, 241, 233, 0.2)',
  interviewtimebg: '#121212',
  interviewsuccess: '#26A69A',
  lightBrown: '#FCEDE3',
  darkBrown: '#C67E4F',
  stageIconColor: '#76747680',
  stagesDarkColor: '#313F62',
  DotColor: '#996b004d',
  darkRed: '#FFF1E6',
  creditBg1: '#dbf8ff',
  creditBg2: '#dedbff ',
  neutral: '#1A1D1F',
  InterviewFormikToolbarBg: chrome.fieldLabel,
  camelColor: '#FFAE1A',
  evaluationBannerColor: '#5C1F1F',
  previewColor: '#FFFAEB',
  previewColorBorder: '#FFE3AD',
  sourceColor: '#0080D0',
  screenColor: '#F9D28C',
  selectColor: '#C39CBD',
  offerColor: '#BBD49A',
  hireColor: '#34A023',
  StageHr: "#EFEFEF",
  seaPink: '#EF9A9A',
  cyan: '#85C8DD',
  cyanBlue: '#B3CBED',
  palePeach: '#FFE2AC',
  blueDark: 'rgba(0, 31, 92, 1)',
  bodyColor: chrome.workspace,
  lightBlue: '#f6f8fc',
  darkYellow: '#FFF6DA',
  cerebellumGrey: "#CDCBCD",
  verticalBarLineColor: '#585558',
  lightSeaGreen:'#1B9AAA',
  SlateBlue:'#5E4DB2',
  subscriptionBorderColor:'#ede8ed',
  lowCreditLoaderColor:'#ff3d00',
  scroll: '#c8c8c8',
  lightOrange:'#FFE3CF',
  lightRed:'#FED9DF',
  darkDoubleRed:'#C00',
  tagPremiumColor: '#FFEBEE',
  tagDefaultColor : '#eae7ea',
  tagBlueBgColor:'#C2D3EB',
  darkThemBoxBgColor: chrome.surface,
  dark:'#000000',
  darkLight:'#2a2a2a',
  darkGrayBackground:'#292929',
  darkTagGreenBg : '#1E423C',
  darkTagGreenTextColor: '#C9F3EF',
  darkHeaderBg:'#212529',
  skeltonBaseColor: '#343B45',
  skeltonHighlightColor :'#4E5866',
  toastErrorBg: '#e35353',
  toastErrorBorderColor: '#ef9a9a',
  toastErrorIconColor:'#ffebee',
  toastErrorTextColor: '#C9F3EF',
  toastSuccessIconColor: '#80cbc4',
  toastSuccessBorderColor: "#00796b",
  toastSuccessBg: '#1E423C',
  selectBg: chrome.card,
  customMultiSelectOptionbg:'#383838',
  actionsIconColor: chrome.onHeader,
   tableHeaderBg: chrome.header,
   tableBodyBg: chrome.surface,
   tableRowBg: chrome.fieldLabel,
   tableRowBorder: '#404750',
   tagChips: '#383838',
   toothShadeIconColor: '#C2E8EB',
   LineGraphTextColor: '#e8e8e8',
   LineGraphBorderColor: '#585558',
   modalInnerBg : chrome.surface,
   occyEventTileColor: '#0c1a33ff',
   externalEventTileColor: '#C7932E',
   delegatedEventTileColor: '#00796B',
   profileDropdownBgColor: '#181818',
   darkTileBg: '#212121',
   modalInnerSideBgColor:'#222222',
   darkSecondaryColor: '#A00161',

  // ---------------------------------------------------------------------
  // Design system tokens (UI/UX revamp - additive, do not remove/rename
  // existing keys above; new components should prefer these tokens).
  // Non-color tokens mirror the light theme so components can share a
  // single set of size/spacing values across themes.
  // ---------------------------------------------------------------------

  // Radius scale
  radiusXs: '4px',
  radiusSm: '8px',
  radiusMd: '12px',
  radiusLg: '16px',
  radiusXl: '20px',
  radiusPill: '999px',

  // Spacing scale (4px base grid)
  space1: '4px',
  space2: '8px',
  space3: '12px',
  space4: '16px',
  space5: '20px',
  space6: '24px',
  space7: '32px',
  space8: '40px',

  // Typography scale
  fontSizeXs: '11px',
  fontSizeSm: '12px',
  fontSizeBase: '14px',
  fontSizeMd: '16px',
  fontSizeLg: '18px',
  fontSizeXl: '20px',
  fontSize2xl: '24px',
  fontSize3xl: '32px',
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,

  // Elevation / shadow scale (soft, dark-safe - relies on lighter borders
  // more than shadows, since box-shadow reads poorly on dark backgrounds)
  shadowSm: '0 1px 2px rgba(0, 0, 0, 0.35)',
  shadowMd: '0 4px 12px rgba(0, 0, 0, 0.45)',
  shadowLg: '0 12px 32px rgba(0, 0, 0, 0.55)',
  shadowCard: '0 0 0 1px rgba(255, 255, 255, 0.04)',

  // Semantic chrome
  headerBg: chrome.header,
  headerForeground: '#FFFFFFCC',
  headerAvatarBg: '#2FB3A0',
  onHeader: chrome.onHeader,
  workspaceBg: chrome.workspace,
  workspaceRgb: chrome.workspaceRgb,
  cardBg: chrome.card,
  radiusCard: chrome.radiusCard,
  radiusModal: chrome.radiusModal,
  dropZoneBg: chrome.dropZone,
  portletBg: chrome.workspace,
  modalBg: chrome.modal,
  modalHeaderBg: chrome.modalHeader,
  modalPanelBg: chrome.modalPanel,

  // Semantic surface aliases (map onto existing raw colors)
  surface: chrome.surface,
  surfaceSubtle: chrome.surfaceSubtle,
  surfaceHover: chrome.fieldLabel,
  borderSubtle: '#373737',
  textPrimary: '#F5F5F5',
  textSecondary: '#9C9C9C',
  tableText: chrome.onHeader,
  paginationActiveBg: '#dc601e',
  paginationActiveColor: chrome.onHeader,
  paginationMuted: '#C8C8C8',
  paginationBtnBg: 'transparent',
  paginationBtnBorder: 'rgba(255, 255, 255, 0.35)',
  paginationBtnColor: chrome.onHeader,

  // Settings column is the greyer surface; the page to the right stays workspace
  navPanelBg: chrome.surface,
  navItemBg: chrome.card,
  navItemText: '#C9CDD4',
  navItemShadow: 'none',
  navItemHoverBg: chrome.fieldLabel,
  navItemActiveBg: '#dc601e',
  navItemActiveText: chrome.onHeader,
  navSectionText: chrome.onHeader,

  // Detail "label block + value" rows (candidate overview, application modal)
  fieldLabelBg: chrome.fieldLabel,
  fieldLabelText: chrome.onHeader,
  fieldValueBg: chrome.card,
  fieldRowBg: chrome.card,
  // Stage / Jobs / Notes: dark label bar, grey action pane (XD popup)
  fieldActionLabelBg: chrome.card,
  fieldActionRowBg: chrome.fieldLabel,
  fieldRowBorder: 'none',
  fieldRowShadow: 'none',

  // Solid identity pills in detail headers (job title / rating)
  tagTealBg: '#2E6F69',
  tagTealText: '#D7F2EF',
  tagGoldBg: '#6B5628',
  tagGoldText: '#F5E3BE',

  // Recruiting pipeline / dashboard stat-card palette (reference design,
  // muted for dark backgrounds while keeping the same hue identity)
  pipelineAppliedBg: '#3A2530',
  pipelineAppliedText: '#F3B8C6',
  pipelineScreenedBg: '#3A3320',
  pipelineScreenedText: '#EAD497',
  pipelineInterviewBg: '#1E3B34',
  pipelineInterviewText: '#9FE0CD',
  pipelineOfferBg: '#2E362A',
  pipelineOfferText: '#C7D4BB',
  pipelineHiredBg: '#22314A',
  pipelineHiredText: '#AFC7E8',
};

export default darktheme;
